<script>
  import { getContext } from 'svelte';
  import ContentBox from '../ContentBox/ContentBox.svelte';
  import LoadProfileForm from './LoadProfileForm.svelte';

  const state = getContext('state');
</script>

<div class="mt-4  flex  flex-col  justify-center  items-center" style="height: calc(100vh - 250px)">
    <h2 class="text-6xl  text-gray-700  text-center  font-antonio  mb-2  underline">
      Get started
    </h2>
    <br />
    <ContentBox border={true}>
      <LoadProfileForm home={true} />
    </ContentBox>
</div>
